import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`;

export const SubSectionTitle = styled.h2`
  font-size: 18px;
  margin: 24px 0;
  color: ${customPalette.grey.main};
`;
